import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import Cookies from 'js-cookie';
import HtmlParser from 'react-html-parser';
import { ArabicToPersian } from 'utils/ConvertToPersianTextFromArabic';
import { Post } from 'Xhr/Xhr';

export const GetDocumentSummury = async (
  data,
  mode,
  setLoading,
  navigate,
  screenWidth
) => {
  setLoading(true);

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_PATIENT_GET_DOCUMENT_SUMMARY}`,
    true,
    {
      ...data,
    }
  ).then((response) => {


    if (response.data.resCode === 1) {
      if (mode === 'preview') {
        navigate(
          screenWidth > 1024
            ? '/main/PatientsForVisitPreview'
            : '/PatientsForVisitPreview',
          {
            state: { html_data: response.data.Data },
          }
        );
      }
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
    setLoading(false);
  });
};
